import { render, staticRenderFns } from "./GolStatsDataFull.vue?vue&type=template&id=b82d35e0&scoped=true&"
import script from "./GolStatsDataFull.vue?vue&type=script&lang=js&"
export * from "./GolStatsDataFull.vue?vue&type=script&lang=js&"
import style0 from "./GolStatsDataFull.vue?vue&type=style&index=0&id=b82d35e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82d35e0",
  null
  
)

export default component.exports